import React from "react";
import ProposalSettingsSection from "../../general/components/proposals/ProposalSettingsSection";

function ProposalSettings() {
  return <ProposalSettingsSection />;
}

export default ProposalSettings;
